export default __webpack_public_path__ + "locales/lv/ArchiveDialog.json?hash=e0b6ea77b3f831427a65c6ce41d2740b";